import axios from 'axios';
import router from '../router';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const reqbackup = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const req = (method, url, params) => {
  let instance = axios.create({
      method: method,
      url: url,
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          token: localStorage.getItem('logintoken')
      },
      data: params,
      traditional: true,
      transformRequest: [
          function(data) {
              let ret = ''
              for (let it in data) {
                  ret +=
                      encodeURIComponent(it) +
                      '=' +
                      encodeURIComponent(data[it]) +
                      '&'
              }
              return ret
          }
      ],
      transformResponse:function(data){
          let obj = JSON.parse(data)
          if (obj.code === '2001' ){
            router.replace({
              path: '/login'
            })
          }
          return obj;
      }
    });

   instance.interceptors.request.use(
     config => {
       const token = sessionStorage.getItem('token')
       if (token ) { // 判断是否存在token，如果存在的话，则每个http header都加上token
         config.headers.authorization = token  //请求头加上token
       }
       return config
     },
     err => {
       return Promise.reject(err)
     })

  instance.interceptors.response.use(
    response => {
      //拦截响应，做统一处理
      if (response.data.code) {
        switch (response.data.code) {
          case -999:
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
        }
      }
      return response
    },
    //接口错误状态处理，也就是说无响应时的处理
    error => {
      return Promise.reject(error.response.status) // 返回接口返回的错误信息
    })
    return instance.request({}).then(res => res.data)
};


// 通用公用方法
const jsonreq = (url, params) => {
    return axios({
        method: 'post',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true
    }).then(res => {
      if (res.data.code === -999){
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
      }
      return res.data
    });
};


export {
    loginreq,
    req,
    jsonreq
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js